import { AxiosRequest } from 'src/lib/axios/Axios';

export const updateOrderState = async ({
  order_id,
  order_state_id,
  comments
}: {
  order_id: string;
  order_state_id: string;
  comments?: string;
}) => {
  const response = await AxiosRequest.post('/order/state', {
    order_id,
    order_state_id,
    comments
  });

  return response.data;
};
